import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Stack } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { SubmitButton } from '@fortress-technology-solutions/fortress-component-library/Atoms_Portal';
import Alert from 'components/Atoms/Alert';

const ContinueButton = ({ error, children, disabled, sx, to, ...props }) => {
  return (
    <Stack>
      <SubmitButton
        datatestid={'continue-button'}
        component={to ? ReactRouterLink : undefined}
        disabled={disabled}
        to={to}
        variant={'primary'}
        sx={{
          position: 'relative',
          zIndex: 2,
          margin: '32px auto',
          maxWidth: '400px',
          width: { xs: 'calc(100vw - 64px)', sm: 300 },
          ...sx,
        }}
        {...props}
      >
        {children ?? <FormattedMessage id="afforda.continue" />}
      </SubmitButton>
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
};

export default ContinueButton;
